export enum PrepaymentOptions {
  HALF = "Prepayment",
  FULL = "FullPrepayment",
}
